<template>
    <div v-show="props.loading" class="app-loader">
        <div class="app-loader-loader"></div>
        {{ i18n.t('loading') }}
    </div>
</template>

<script setup lang="ts">
import type { PropType } from 'vue';
import { useI18n } from 'vue-i18n';

const i18n = useI18n();

const props = defineProps({
    loading: {
        type: Boolean as PropType<boolean>,
        required: false,
        default: true,
    },
});
</script>
